var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAverageTimeGateIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 30,
    viewBox: "0 0 59 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "tk6a0op73b",
    width: 27.5,
    height: 5,
    x: -3.75,
    y: 0,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "onvo89jjra",
    d: "M0.625 0.625H23.125V4.375H0.625z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#BCBCBC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.845c1.138 0 2.183-.3 3.136-.9.939-.585 1.685-1.38 2.24-2.385.555-1.005.832-2.108.832-3.308 0-1.2-.277-2.303-.832-3.308-.555-.99-1.301-1.778-2.24-2.363-.953-.585-1.998-.878-3.136-.878-1.138 0-2.183.293-3.136.878-.939.585-1.685 1.373-2.24 2.363-.555 1.005-.832 2.108-.832 3.308 0 1.2.277 2.303.832 3.308.555 1.005 1.301 1.8 2.24 2.385.953.6 1.998.9 3.136.9zm6.25-11.814c.555.735.982 1.538 1.28 2.408.314.9.47 1.838.47 2.813 0 1.53-.363 2.948-1.088 4.253-.711 1.275-1.671 2.288-2.88 3.038-1.237.765-2.581 1.147-4.032 1.147-1.45 0-2.795-.382-4.032-1.147-1.209-.75-2.169-1.763-2.88-3.038C.363 14.2 0 12.782 0 11.252c0-1.53.363-2.948 1.088-4.253.711-1.276 1.671-2.288 2.88-3.038C5.205 3.195 6.549 2.813 8 2.813c.91 0 1.806.172 2.688.518.825.33 1.593.787 2.304 1.372l1.259-1.372c.398.345.817.787 1.258 1.327l-1.258 1.373zm-7.125 6.188V6.594h1.75v5.625h-1.75zM10.667 0v1.89H5.333V0h5.334z",
    transform: "translate(0 5) translate(.324 .584)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13 3H24V30H13z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.247
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18.75 0 18.75 2.998 0 2.998z",
    transform: "translate(14)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.875 3.125v26.25h15V3.125h-15zM5 6.875h8.75c1.036 0 1.875.84 1.875 1.875v8.75c0 1.036-.84 1.875-1.875 1.875H5c-1.036 0-1.875-.84-1.875-1.875V8.75c0-1.036.84-1.875 1.875-1.875z",
    transform: "translate(14)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14) translate(20 15)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#onvo89jjra"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "1maaovrjsc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tk6a0op73b"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 3.75,
    x: -3.125,
    y: 0.625,
    stroke: "#000",
    strokeWidth: 1.25,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.25,
    d: "M-1.25 4.16L2.036.874M5 4.16L8.286.874M11.25 4.16L14.536.874M17.5 4.16L20.786.874",
    mask: "url(#1maaovrjsc)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageTimeGateIcon);
export default __webpack_public_path__ + "static/media/average_time_gate_icon.3cab1cbe7cac4f2f43f8c613f26fc6c1.svg";
export { ForwardRef as ReactComponent };